import {AppRouter} from 'aurelia-router';

export function apply() {
	/**
	 * Override the original AppRouter.generate function by removing leading "/"
	 * See https://github.com/aurelia/templating-router/issues/57
	 */
	(function fixGeneratedRoutes(generateOrig: Function) {
		AppRouter.prototype.generate = function(name: string, params?: any, options?: any): string {
			let href = generateOrig.call(this, name, params, options);
			
			if (href.charAt(0) === '/') {
				href = href.substr(1);
			}
			
			return href;
		}
	})(AppRouter.prototype.generate);
}